import { type BubbleDO } from "../../data/bubble.data";
import { type StablecoinLatestDO } from "../../data/pie-chart.data";


class BubbleTransform {

    public defiTradfiTVLtoBubbleDO(data: any): BubbleDO {
        // Transform the raw data to BubbleDO format
        return data as BubbleDO;
    }

    public stablecoinVsBanksToBubbleDO(data: StablecoinLatestDO): BubbleDO {
        // Transform stablecoin vs banks data to bubble format
        const bubbleData: BubbleDO = {};
        
        if (data.stablecoin_vs_banks) {
            Object.entries(data.stablecoin_vs_banks).forEach(([key, value]) => {
                bubbleData[key] = {
                    value: (value as { value: number }).value,
                    type: (value as { type: string }).type
                }   
            });
        }
        
        return bubbleData;
    }
}

export const bubbleTransform = new BubbleTransform()